// src/globalData.js
const globalData = {
  store_list: [],
  attribute_tree: [],
  sap_sku_list:[],
  all_cat_list:[],
  bc_sku_list:[]
};

export default globalData;
